import { ApiFieldError } from 'src/types';
import { actionCreatorFactory } from 'typescript-fsa';
/**
 * Action Creators
 */
export type UpdateDocumentParams = any;
export type APIError = ApiFieldError;

export const actionCreator = actionCreatorFactory(`@@manager/documents`);

export const describeDocumentActions = actionCreator.async<
  any,
  any,
  APIError[]
>('request-documents');

export const updateDocumentActions = actionCreator.async<
  UpdateDocumentParams,
  any,
  APIError[]
>(`update`);
